import { useUser } from '@vivaldis/session'
import { useMemo } from 'react'
import { useUserHasInterimWebAccess } from './useUserHasInterimWebAccess'

export const useUserHasInterimExtendContractAccess = (): boolean => {
  const user = useUser()
  const userHasInterimWebAccess = useUserHasInterimWebAccess()
  return useMemo(() => {
    if (!userHasInterimWebAccess) return false

    const permission = user?.permissions.find(
      permission => permission.companyId === user?.company?.id
    )

    const userHasHoursValidationPermissionForInterim =
      permission?.interim4dPermissions?.permissions?.some(
        permission => permission === 'extending_contracts'
      ) || false

    return userHasHoursValidationPermissionForInterim
  }, [user?.company?.id, user?.permissions, userHasInterimWebAccess])
}
